import { Link } from '@on3/ui-lib/components/Link';

import styles from './AppBadges.module.scss';

export const AppBadges = () => {
  return (
    <div className={styles.container}>
      <Link href="https://apps.apple.com/us/app/on3-app/id1629727374">
        <img
          alt="Apple Store Logo"
          src="https://on3static.com/static/on3/apple-store.png"
        />
      </Link>
      <Link href="https://play.google.com/store/apps/details?id=com.on3">
        <img
          alt="Google Play Logo"
          src="https://on3static.com/static/on3/google-play.png"
        />
      </Link>
    </div>
  );
};
